// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Pw6d","label":"Section_label__2kT-I","contentWrap":"Section_contentWrap__HGv-o","footer":"Section_footer__U4MFN","footerInner":"Section_footerInner__3jHZo"};